var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 17c0-9.389-7.611-17-17-17S0 7.611 0 17c0 8.485 6.217 15.518 14.344 16.794v-11.88h-4.317V17h4.317v-3.745c0-4.26 2.538-6.614 6.42-6.614 1.86 0 3.806.332 3.806.332v4.183h-2.143c-2.112 0-2.77 1.31-2.77 2.655V17h4.714l-.754 4.914h-3.96v11.88C27.782 32.517 34 25.485 34 17Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.621 21.914 24.375 17H19.66v-3.189c0-1.344.659-2.655 2.77-2.655h2.144V6.973S22.63 6.64 20.77 6.64c-3.883 0-6.421 2.353-6.421 6.614V17H10.03v4.914h4.317v11.88a17.126 17.126 0 0 0 5.312 0v-11.88h3.961Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h34v34H0z"
  })))));
};
export default SvgFacebook;